// extracted by mini-css-extract-plugin
export default {"root":"Currency_root_iLh1k","rootPositive":"Currency_rootPositive_p1rKp Currency_root_iLh1k","rootNegative":"Currency_rootNegative_BfE8j Currency_root_iLh1k"};